import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import type { ConfigurationItem } from '../../types/common'

export type AnnulOperationDescriptor = {
  /** The configuration item variant used for icon rendering and navigation. */
  configurationItemVariant: Exclude<
    ConfigurationItem,
    'annulOperation' | 'hideTemplate' | 'hideGlMap'
  >
  entityClassTranslation: string
}

export const useAnnulOperationDescriptors = () => {
  const translate = useTranslate()
  const descriptors: Record<string, AnnulOperationDescriptor> = useMemo(
    () => ({
      TemplateCreateOperation: {
        configurationItemVariant: 'template',
        entityClassTranslation: translate(
          'annulOperation.entityClass.template',
        ),
      },
      LibraryCreateOperation: {
        configurationItemVariant: 'library',
        entityClassTranslation: translate('annulOperation.entityClass.library'),
      },
      ParameterDefinitionCreateOperation: {
        configurationItemVariant: 'parameterDefinition',
        entityClassTranslation: translate(
          'annulOperation.entityClass.parameter',
        ),
      },
      ParameterValueCreateOperation: {
        configurationItemVariant: 'parameterValue',
        entityClassTranslation: translate(
          'annulOperation.entityClass.parameterValue',
        ),
      },
      EnumDefinitionCreateOperation: {
        configurationItemVariant: 'enumDefinition',
        entityClassTranslation: translate('annulOperation.entityClass.enum'),
      },
      EnumLiteralCreateOperation: {
        configurationItemVariant: 'enumLiteral',
        entityClassTranslation: translate(
          'annulOperation.entityClass.enumLiteral',
        ),
      },
      RegisteredTenantCreateOperation: {
        configurationItemVariant: 'tenant',
        entityClassTranslation: translate('annulOperation.entityClass.tenant'),
      },
      GlMapCreateOperation: {
        configurationItemVariant: 'glMap',
        entityClassTranslation: translate('annulOperation.entityClass.glMap'),
      },
      ReconciliationSpecCreateOperation: {
        configurationItemVariant: 'reconciliationSpec',
        entityClassTranslation: translate(
          'annulOperation.entityClass.reconciliationSpec',
        ),
      },
    }),
    [translate],
  )

  return descriptors
}
